import Backbone from "backbone";
import _ from "underscore";
import $ from "jquery";

const PATH = "/api/v2/settings/security/keys";

const SecurityKeyModel = Backbone.Model.extend({
    initialize(attributes, options) {
        this.type = options.type || this.get("type");
    },

    urlRoot: PATH,

    sync(method, model, options) {
        if (method === "create") {
            if (
                this.attributes.type === "WEBHOOK" &&
                this.attributes.algorithm === "SSL_PKCS_12"
            ) {
                const formData = new FormData();
                formData.append(
                    "file",
                    this.attributes.file,
                    this.attributes.file?.name
                );
                const metadata = JSON.stringify(
                    _.omit(this.attributes, ["file", "key"])
                );
                formData.append("metadata", metadata);
                return Backbone.ajax(this.url(), {
                    type: "POST",
                    processData: false,
                    contentType: false,
                    data: formData,
                });
            } else if (
                this.attributes.type === "WEBHOOK" &&
                this.attributes.algorithm === "OAUTH_SFDC_PASSWORD"
            ) {
                this.set("type", this.type);
                options.attrs = _.omit(this.attributes, ["file"]);
            } else {
                this.set("type", this.type);
                options.attrs = _.omit(
                    this.attributes,
                    "flag",
                    "file",
                    "password",
                    "file-password",
                    "sfdc-password"
                );
            }
        }
        return Backbone.sync.call(this, method, model, options);
    },

    fetchInfo() {
        const deferred = $.Deferred();
        Backbone.ajax({
            url: this.url(),
            type: "GET",
            dataType: "json",
        }).done((data) => deferred.resolve(data));
        return deferred;
    },
});

SecurityKeyModel.create = function (type) {
    return new SecurityKeyModel(null, {
        type,
    });
};

export default SecurityKeyModel;
